import React, { useMemo, useState } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Loading from '../components/loading';
import ErrorMessage from '../components/errorMessage';
import { useNavigate } from 'react-router-dom';
import logo from '../../src/assets/logo_sigo.png';
import { useLogin } from './hooks/useLogin';
import { useThemeContext } from '../context/ThemeContext';

function LoginForm() {
  const navigate = useNavigate();
  const { login } = useLogin();
  const { darkMode } = useThemeContext();

  // O login fica fora do Layout, então precisa do seu próprio tema MUI
  // para que componentes como o ErrorMessage sigam o modo escuro.
  const theme = useMemo(
    () => createTheme({ palette: { mode: darkMode ? 'dark' : 'light' } }),
    [darkMode],
  );
  const [isLoading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email || !password) {
      setLoading(false);
      setShowErrorMessage(true);
      setErrorMessage('Por favor, preencha todos os campos.');
      return;
    }

    const input = {
      email: email,
      password: password,
    };

    login(input)
      .then((returnFromApi) => {
        sessionStorage.setItem('token', returnFromApi.data.token);
        sessionStorage.setItem('dentistIdFromUser', returnFromApi.data.dentistIdFromUser);
        sessionStorage.setItem('userEmail', email);
        sessionStorage.setItem('roles', JSON.stringify(returnFromApi.data.roles));
        sessionStorage.setItem('userDisplayName', returnFromApi.data.userDisplayName ?? '');

        navigate('/home');
      })
      .catch((error) => {
        if (error.response) {
          setErrorMessage(error.response.data);
        } else {
          setErrorMessage('Ocorreu um erro interno no sistema, por favor contate o administrador');
        }
        setShowErrorMessage(true);
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container
        fluid
        className="d-flex justify-content-center align-items-center vh-100 bg-body-tertiary"
        data-bs-theme={darkMode ? 'dark' : 'light'}
      >
        <Row className="w-100 justify-content-center">
          <Col xs={12} sm={8} md={6} lg={4}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img
                src={logo}
                alt={'Imagem'}
                style={{
                  maxWidth: '350px',
                  maxHeight: '350px',
                  objectFit: 'contain',
                }}
              />
            </div>
            <br />
            <Card className="p-4 shadow-sm border-0 rounded-4">
              {isLoading && <Loading isToHidden={false} />}
              <Card.Body>
                {showErrorMessage && (
                  <ErrorMessage
                    message={errorMessage}
                    show={showErrorMessage}
                    setShow={setShowErrorMessage}
                  />
                )}

                <Form
                  onSubmit={handleSubmit}
                  className={`form-container ${isLoading ? 'loading' : ''}`}
                >
                  <Form.Group className="mb-4">
                    <Form.Control
                      data-cy="login-email"
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoFocus
                    />
                  </Form.Group>
                  <Form.Group className="mb-4" controlId="formPassword">
                    <Form.Control
                      data-cy="login-password"
                      type="password"
                      placeholder="Senha"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>
                  <div className="d-flex justify-content-center">
                    <Button data-cy="login-submit" variant="primary" type="submit" className="w-50">
                      Entrar
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </ThemeProvider>
  );
}

export default LoginForm;
